<template>
  <v-card outlined>
    <!-- <h2 class="text-center colorblue">Настройка рассылки по 44 ФЗ</h2> -->
    <v-row no-gutters>
      <v-col cols="12" v-if="turnOn">
        <div class="btn-group">
          <v-btn color="success" @click="SaveMailWinners">
            <v-icon left> mdi-content-save </v-icon>
            Сохранить
            <loading v-if="load" />
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" sm="12" md="12" class="pl-4 pr-4 pt-4 pb-4">
        <v-checkbox
          v-model="turnOn"
          :label="!turnOn ? 'Рассылка выключена' : 'Рассылка включена'"
        />
      </v-col>
      <v-col cols="12" v-if="turnOn">
        <v-row no-gutters>
          <v-col cols="12">
            <v-row>
              <v-col cols="6">
                <v-col cols="12">
                  <v-row no-gutters>
                    <v-col md="6">
                      <RangeSlider
                        caption="Количество побед"
                        :min="WinnersMin"
                        :max="WinnersMax"
                        v-model="CountWinners"
                      />
                      <RangeSlider
                        caption="Сумма обеспечения исполнения контракта"
                        :min="ContractMin"
                        :max="ContractMax"
                        v-model="ContractSumm"
                      />
                      <RangeSlider
                        caption="Начальная максимальная цена контракта"
                        :min="StartContractMin"
                        :max="StartContractMax"
                        v-model="StartContractSumm"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="pl-4 pr-4 pt-4">
                  <v-row>
                    <v-col cols="9">
                      <h3>Переменные для шаблона</h3>
                      <p>&lt;%= shortName %&gt; // Наименование организации</p>
                      <p>&lt;%= inn %&gt; // ИНН организации</p>
                      <p>
                        &lt;%= protocolLink %&gt; // линк на протокол по закупке
                      </p>
                      <p>
                        &lt;%= protocol.notificationNumber %&gt; // Номер
                        протокола
                      </p>
                      <p>&lt;%= protocol.name %&gt; // Предмет закупки</p>
                      <p>&lt;%= unsubscribe %&gt; // Ссылка на отписатся</p>
                      <p>&lt;%= link %&gt; // ссылка на формить гарантию</p>
                      <p>
                        &lt;%= protocol %&gt; // Доступны поля все которые есть
                        в протоколе
                      </p>
                      <p>
                        &lt;% table.forEach(function(bank){ %&gt; &lt;%if
                        (bank.ratio===1) { %&gt; &lt;%-
                        include('bankTablesRatio', {bank, link, linkText, temp,
                        protocol,calcRegisterId, email}); %&gt; &lt;% } else
                        {%&gt; &lt;%- include('bankTables', {bank, link,
                        linkText, temp, protocol,calcRegisterId, email}); %&gt;
                        &lt;% } %&gt; &lt;% }); %&gt;
                      </p>
                      <p>
                        &lt;%- include('tableInfo',{dateFrom, dateTo, days,
                        summ, temp}) %&gt; // Генерация информации по шаблонам
                      </p>
                    </v-col>
                    <v-col cols="3">
                      <v-row no-gutters>
                        <v-col cols="12" class="pr-4"
                          ><v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="date"
                                label="Дата расчетов по"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <v-date-picker v-model="date" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="menu = false">
                                Отменить
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu.save(date)"
                              >
                                Применить
                              </v-btn>
                            </v-date-picker>
                          </v-menu></v-col
                        >
                        <v-col cols="12" class="pr-4"
                          ><v-text-field
                            v-model="ratio"
                            label="Коэффициент"
                            type="number"
                            :step="0.1"
                            :max="1"
                            :min="0.1"
                        /></v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-col>
              <v-col cols="6">
                <v-row>
                  <v-col cols="6"
                    ><v-btn color="success" @click="() => setAll(true)">
                      <v-icon left>
                        mdi-checkbox-multiple-marked-outline
                      </v-icon>
                      Выделить все
                    </v-btn></v-col
                  >
                  <v-col cols="6"
                    ><v-btn color="warning" @click="() => setAll(false)">
                      <v-icon left> mdi-select </v-icon>
                      Отчистить все
                    </v-btn></v-col
                  >
                </v-row>
                <v-row class="checkbox_group">
                  <v-col cols="3" v-for="item in bankList" :key="item.id">
                    <div
                      @click="(evt) => setData(evt, item)"
                      :class="
                        banksListLoading
                          ? 'checkbox_new disabled'
                          : 'checkbox_new'
                      "
                    >
                      <v-icon left v-if="item.mailing">
                        mdi-checkbox-marked-outline
                      </v-icon>
                      <v-icon left v-else> mdi-checkbox-blank-outline </v-icon>
                      {{ item.name }}
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" class="pl-4 pr-4 pt-4 pb-4">
            <h3>Базовый шаблон ниже</h3>
            <HtmlViewer v-model="docs" height="300px" />
          </v-col>
          <v-col cols="12" class="pl-4 pr-4 pt-4 pb-4">
            <h3>Базовый шаблон строка банка если bank.ratio не = 1</h3>
            <p>&lt;%= bank.bankName %&gt; // Наименование банка в системе</p>
            <p>&lt;%= bank.productName %&gt; // Продукт банка в системе</p>
            <p>&lt;%= bank.rate %&gt; // Рейтинг банка в системе</p>
            <p>
              &lt;%= Number(bank.ikomsk).toLocaleString('ru') %&gt; // сумма по
              банку без скидки
            </p>
            <p>
              &lt;%= Number(bank.ikomskDiscound).toLocaleString('ru') %&gt; //
              сумма по банку с дисконтом
            </p>
            <p>
              &lt;%= bank.procentDiscound %&gt; // проценты по банку с дисконтом
            </p>
            <p>
              &lt;%=
              encodeURI(`${link}&amp;bank_id=${bank.bank_id}&amp;product_id=${bank.product_id}&amp;temp=${temp}&amp;bank=${bank.bankName}&amp;product=${bank.productName}&amp;opf=${protocol.opf}&amp;calcRegisterId=${calcRegisterId}&amp;email=${email}&amp;param=send`)
              %&gt; // линк по банку
            </p>

            <HtmlViewer v-model="tableBankRow" height="300px" />
          </v-col>
          <v-col cols="12" class="pl-4 pr-4 pt-4 pb-4">
            <h3>Базовый шаблон строка банка если bank.ratio = 1</h3>
            <p>
              &lt;%= Number(bank.ikomsk).toLocaleString('ru') %&gt; // сумма по
              банку
            </p>
            <p>&lt;%= bank.procent %&gt; // проценты по банку</p>

            <p>
              &lt;%=
              encodeURI(`${link}&amp;bank_id=${bank.bank_id}&amp;product_id=${bank.product_id}&amp;temp=${temp}&amp;bank=${bank.bankName}&amp;product=${bank.productName}&amp;opf=${protocol.opf}&amp;calcRegisterId=${calcRegisterId}&amp;email=${email}&amp;param=send`)
              %&gt; // линк по банку
            </p>

            <HtmlViewer v-model="tableBankRowRatio" height="300px" />
          </v-col>
          <v-col cols="12" class="pl-4 pr-4 pt-4 pb-4">
            <h3>Расчет данных по Шаблону</h3>
            <p>&lt;%= summ %&gt; // сумма расчета</p>
            <p>&lt;%= dateFrom %&gt; // дата с</p>
            <p>&lt;%= dateTo %&gt; // дата с</p>
            <p>&lt;%= days %&gt; // количество дней</p>
            <HtmlViewer v-model="tempDate" height="300px" />
          </v-col>
          <v-col cols="12" class="pl-4 pr-4 pt-4 pb-4">
            <h3>1 Шаблон</h3>
            <p>
              &lt;%- include('tempDate', { dateFrom, dateTo, days, summ }) %&gt;
              // импорт Расчет данных по Шаблону
            </p>
            <HtmlViewer v-model="temp1" height="300px" />
          </v-col>
          <v-col cols="12" class="pl-4 pr-4 pt-4 pb-4">
            <h3>2 Шаблон</h3>
            <p>
              &lt;%- include('tempDate', { dateFrom, dateTo, days, summ }) %&gt;
              // импорт Расчет данных по Шаблону
            </p>
            <HtmlViewer v-model="temp2" height="300px" />
          </v-col>
          <v-col cols="12" class="pl-4 pr-4 pt-4 pb-4">
            <h3>3 Шаблон</h3>
            <p>
              &lt;%- include('tempDate', { dateFrom, dateTo, days, summ }) %&gt;
              // импорт Расчет данных по Шаблону
            </p>
            <HtmlViewer v-model="temp3" height="300px" />
          </v-col>
          <v-col cols="12" class="pl-4 pr-4 pt-4 pb-4">
            <h3>4 Шаблон</h3>
            <p>
              &lt;%- include('tempDate', { dateFrom, dateTo, days, summ }) %&gt;
              // импорт Расчет данных по Шаблону
            </p>
            <HtmlViewer v-model="temp4" height="300px" />
          </v-col>
          <v-col cols="12" class="pl-4 pr-4 pt-4 pb-4">
            <h3>5 Шаблон</h3>
            <p>
              &lt;%- include('tempDate', { dateFrom, dateTo, days, summ }) %&gt;
              // импорт Расчет данных по Шаблону
            </p>
            <HtmlViewer v-model="temp5" height="300px" />
          </v-col>
          <v-col cols="12" class="pl-4 pr-4 pt-4 pb-4">
            <h3>6 Шаблон</h3>
            <p>
              &lt;%- include('tempDate', { dateFrom, dateTo, days, summ }) %&gt;
              // импорт Расчет данных по Шаблону
            </p>
            <HtmlViewer v-model="temp6" height="300px" />
          </v-col>
          <v-col cols="12" class="pl-4 pr-4 pt-4 pb-4">
            <h3>7 Шаблон</h3>
            <p>
              &lt;%- include('tempDate', { dateFrom, dateTo, days, summ }) %&gt;
              // импорт Расчет данных по Шаблону
            </p>
            <HtmlViewer v-model="temp7" height="300px" />
          </v-col>
          <v-col cols="12" class="pl-4 pr-4 pt-4 pb-4">
            <h3>8 Шаблон</h3>
            <p>
              &lt;%- include('tempDate', { dateFrom, dateTo, days, summ }) %&gt;
              // импорт Расчет данных по Шаблону
            </p>
            <HtmlViewer v-model="temp8" height="300px" />
          </v-col>
          <v-col cols="12" class="pl-4 pr-4 pt-4 pb-4">
            <h3>9 Шаблон</h3>
            <p>
              &lt;%- include('tempDate', { dateFrom, dateTo, days, summ }) %&gt;
              // импорт Расчет данных по Шаблону
            </p>
            <HtmlViewer v-model="temp9" height="300px" />
          </v-col>
        </v-row>
        <v-col md="12">
          <v-row no-gutters>
            <v-col
              sm="2"
              md="2"
              class="pl-4 pr-4"
              style="
                display: flex;
                column-gap: 20px;
                justify-content: space-around;
              "
              ><v-checkbox
                label="Смена темы в письме"
                v-model="showTitle"
                class="check" />
              <v-checkbox
                label="Составная тема"
                v-model="compositeTitle"
                class="check"
            /></v-col>

            <v-col sm="10" md="10" class="pl-4 pr-4">
              <v-text-field
                v-model="title"
                label="Тема письма"
                type="text"
                v-if="showTitle"
              />
              <span v-if="compositeTitle">{{
                `Для "\${company_name}". ${title}`
              }}</span>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="12">
          <v-row no-gutters>
            <v-col sm="3" md="3" class="pl-4 pr-4"
              ><v-checkbox
                label="Тестовая рассылка"
                v-model="malingTest"
                class="check"
            /></v-col>
            <v-col sm="9" md="9" class="pl-4 pr-4">
              <v-text-field
                v-model="testEmail"
                label="Тестовый Email"
                type="text"
                :step="0.1"
                :max="1"
                :min="0.1"
                v-if="malingTest"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-col>

      <v-col cols="12">
        <div class="btn-group">
          <v-btn color="success" @click="SaveMailWinners">
            <v-icon left> mdi-content-save </v-icon>
            Сохранить
            <loading v-if="load" />
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import RangeSlider from "../../components/rangeSlider.vue";
import loading from "../../components/loading.vue";
import HtmlViewer from "../../components/HtmlViewer.vue";

export default {
  name: "fz44",
  components: { RangeSlider, loading, HtmlViewer },
  data: () => ({
    CountWinners: [3, 20],
    WinnersMin: 0,
    WinnersMax: 10000,
    ContractSumm: [40000, 3000000],
    ContractMin: 0,
    ContractMax: 3000000000,
    StartContractSumm: [40000, 3000000],
    StartContractMin: 0,
    StartContractMax: 10000000000,
    search: "",
    malingTest: false,
    testEmail: "",
    load: false,
    menu: null,
    date: null,
    ratio: 0,
    turnOn: false,
    docs: "",
    tableBankRow: "",
    tableBankRowRatio: "",
    tempDate: "",
    temp1: "",
    temp2: "",
    temp3: "",
    temp4: "",
    temp5: "",
    temp6: "",
    temp7: "",
    temp8: "",
    temp9: "",
    showTitle: false,
    compositeTitle: false,
    title: "",
  }),
  methods: {
    async SaveMailWinners() {
      this.load = true;
      const obj = {
        wincol: { min: this.CountWinners[0], max: this.CountWinners[1] },
        contractSum: { min: this.ContractSumm[0], max: this.ContractSumm[1] },
        startContractSum: {
          min: this.StartContractSumm[0],
          max: this.StartContractSumm[1],
        },
        date_to: this.date,
        ratio: this.ratio,
        testEmail: this.testEmail,
        malingTest: this.malingTest,
        turnOn: this.turnOn,
        docs: this.docs,
        tableBankRow: this.tableBankRow,
        tableBankRowRatio: this.tableBankRowRatio,
        tempDate: this.tempDate,
        temp1: this.temp1,
        temp2: this.temp2,
        temp3: this.temp3,
        temp4: this.temp4,
        temp5: this.temp5,
        temp6: this.temp6,
        temp7: this.temp7,
        temp8: this.temp8,
        temp9: this.temp9,
        showTitle: this.showTitle,
        compositeTitle: this.compositeTitle,
        title: this.title,
      };
      this.$store.dispatch("SaveMailWinners", obj).then((data) => {
        this.load = false;
      });
    },
    async LoadMailWinners() {
      this.load = true;
      this.$store.dispatch("LoadMailWinners").then((res) => {
        const { data } = res;
        //set value
        this.CountWinners = [data.wincol.min, data.wincol.max];
        this.ContractSumm = [data.contractSum.min, data.contractSum.max];
        this.StartContractSumm = [
          data.startContractSum.min,
          data.startContractSum.max,
        ];
        this.date = data.date_to;
        this.ratio = data.ratio;
        this.testEmail = data.testEmail;
        this.malingTest = data.malingTest;
        this.turnOn = data.turnOn;
        this.docs = data.docs;
        this.tableBankRow = data.tableBankRow;
        this.tableBankRowRatio = data.tableBankRowRatio;
        this.tempDate = data.tempDate;
        this.temp1 = data.temp1;
        this.temp2 = data.temp2;
        this.temp3 = data.temp3;
        this.temp4 = data.temp4;
        this.temp5 = data.temp5;
        this.temp6 = data.temp6;
        this.temp7 = data.temp7;
        this.temp8 = data.temp8;
        this.temp9 = data.temp9;
        this.load = false;
        this.showTitle = data.showTitle;
        this.compositeTitle = data.compositeTitle;
        this.title = data.title;
      });
    },
    async LoadBankList() {
      await this.$store.dispatch("GET_BANKS_LIST");
    },
    setData(event, item) {
      this.bankList = this.bankList.map((bank) => {
        if (bank.id === item.id) {
          bank.mailing = !item.mailing;
        }
        return bank;
      });
      this.$store.dispatch("SET_BANKS_LIST");
    },
    setAll(val) {
      this.bankList = this.bankList.map((bank) => {
        bank.mailing = val;
        return bank;
      });
      this.$store.dispatch("SET_BANKS_LIST");
    },
  },
  mounted() {
    this.LoadMailWinners();
    this.LoadBankList();
  },
  computed: {
    bankList: {
      get() {
        return this.$store.getters.getBanksList;
      },
      set(val) {
        this.$store.commit("SET_BANKS_LIST", val);
      },
    },
    banksListLoading: {
      get() {
        return this.$store.getters.getBanksListLoading;
      },
    },
  },
};
</script>

<style lang="sass">
.btn-group
  margin: 10px 20px 20px 20px
  display: flex
.pd-1
  padding: 1rem !important
.pd-1-2
  padding: 1rem 2rem !important
.checkbox_new
  &:hover
    cursor: pointer
  &.disabled
    opacity: .5
</style>
